import { NukreisIdEntity, NuKreisIdListEntity } from "./nuKreisId.js";
import { Helper } from "../core/util/helper.js";
import { Grid } from "../core/components/grid.js";
import { RSplitter, RSplitterDirection } from "../core/components/rSplitter.js";
import { FieldInstance } from "../core/components/field.js";
import { IsNumericTextBox } from "../core/components/isNumericTextBox.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { TextBox } from "../core/components/textBox.js";
import { HTTPService } from "../core/util/httpManager.js";
import { BaseComponentProps } from "../core/components/baseComponentProps.js";
import { KeyValuePair, StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
export default class NuKreisIdGrid extends React.Component<NuKreisIdGridProps, NuKreisIdGridState>{
    private gridOptions: kendo.ui.GridOptions;

    constructor(props: NuKreisIdGridProps) {
        super(props)
        this.state = {
            data: props.entity.Data,
            selected: props.entity.Data[0]
        }
        this.initApp();
    }

    private initApp = async () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "MainGroupId",
                    title: this.props.translations["WebSMS.TranslationsEditor.Key"]
                },
                {
                    field: "MainGroup",
                    title: this.props.translations["Statistik.Obergruppe"]
                },
            ]
        };
        //this.setState({});
    }

    private createGrid = () => {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.data}
                    options={this.gridOptions}
                    id="nukreisid"
                    onSelectionChanged={(dataItem: NukreisIdEntity) => {
                        if (Helper.hasValue(dataItem))
                            this.setState({ selected: dataItem })
                        else if (!Helper.hasValue(dataItem) && Helper.hasValue(this.state.selected)) {
                            //wegen weirden timing probleme zwischen React und jQuery
                            this.setState({}, () => {
                                let matchingElement = document.evaluate(`//td[text()='${this.state.selected.MainGroupId}']`, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
                                matchingElement.parentElement.click()
                            })
                        }
                    }}
                    preselectFilter={Helper.hasValue(this.state.selected) ? this.state.selected.MainGroupId.toString() : null}
                />
            </div>
        );
    }

    private updateData = (entity: NukreisIdEntity) => {
        let data = this.state.data;
        let index = data.findIndex(f => f.MainGroupId == entity.MainGroupId);
        data[index] = entity;
        this.setState({ data: data }, () => {
            this.props.onChange({ model: "entity.Data" }, data)
        })
    }

    private createCommonApp = () => {
        return (
            <>
                <EditNukreisId
                    entity={this.state.selected}
                    onChange={this.updateData}
                    translations={this.props.translations}
                />
            </>
        );
    }

    render() {
        if (Helper.hasValue(this.gridOptions)) {
            return (
                <RSplitter direction={RSplitterDirection.Horizontal} initialPercentage={40}>
                    {this.createGrid()}
                    {this.createCommonApp()}
                </RSplitter>
            );
        } else {
            return null;
        }
    }
}

export class EditNukreisId extends React.Component<EditNukreisProps, any>{
    private factory = ComponentHelper.createFactory();
    private TYPES_WITH_PRE_AND_SUFFIX = [
        "AD",
        "MA",
        "MT",
        "DE",
        "BN",
        "ER"
    ];
    private canEditSufAndPrefix: boolean;
    private MAX_VALUE = 2147483647;
    private MIN_VALUE = 1;

    private codes: KeyValuePair<number, string>[] = null;
    private auArts: KeyValuePair<number, string>[] = null;

    constructor(props: EditNukreisProps) {
        super(props)
        this.state = {};
        this.loadDataSources();
        console.log(props)
        this.canEditSufAndPrefix = this.TYPES_WITH_PRE_AND_SUFFIX.findIndex(f => f == props.entity.Type) > -1;
    }

    private loadDataSources = async () => {
        let result = await Promise.all([
            HTTPService.get<KeyValuePair<number, string>[]>("Nukreis/GetCodes"),
            HTTPService.get<KeyValuePair<number, string>[]>("Nukreis/GetAuArts")
        ]);
        this.codes = result[0];
        this.auArts = result[1];
        this.setState({})
    }


    private createRangeNumericTextBox = (field: "min" | "max" | "currentnr") => {
        let label = "";

        let props = this.factory.getDefaultNumericTextBoxProps();
        props.field.min = this.MIN_VALUE;
        props.field.max = this.MAX_VALUE;
        //props.required = true;
        props.field.name = label;
        switch (field) {
            case "min":
                label = this.props.translations["WebCRM.Nukreis.Min"];
                props.value = this.props.entity.MinNr;
                props.onChange = (_, value: number) => {
                    if (Helper.hasValue(value) && Helper.isNumber(value) && ((value < this.props.entity.MaxNr) || !Helper.hasValue(this.props.entity.MaxNr))) {
                        let entity = this.props.entity;
                        entity.MinNr = value;
                        this.props.onChange(entity);
                    }
                }
                break;
            case "max":
                label = this.props.translations["WebCRM.Nukreis.Max"];
                props.value = this.props.entity.MaxNr;
                props.onChange = (_, value: number) => {
                    if (Helper.hasValue(value) && Helper.isNumber(value) && ((value > this.props.entity.MinNr) || !Helper.hasValue(this.props.entity.MinNr))) {
                        let entity = this.props.entity;
                        entity.MaxNr = value;
                        this.props.onChange(entity);
                    }
                }
                break;
            case "currentnr":
                label = Helper.getTranslation("WebCRM.Nukreis.CurrentNr");
                props.value = this.props.entity.CurrentNr;
                props.onChange = (_, value: number) => {
                    if (Helper.hasValue(value) && Helper.isNumber(value)
                        && ((value >= this.props.entity.MinNr) || !Helper.hasValue(this.props.entity.MinNr))
                        && ((value <= this.props.entity.MaxNr) || !Helper.hasValue(this.props.entity.MaxNr))
                    ) {
                        let entity = this.props.entity;
                        entity.CurrentNr = value;
                        this.props.onChange(entity);
                    }
                }
                break;
        }
        return (
            <FieldInstance label={label}>
                <IsNumericTextBox {...props}/>
            </FieldInstance>
           );
    }

    private createTextBox = (field: "suffix" | "prefix" | "description") => {
        let label = "";

        let props = this.factory.getDefaultTextBoxProps();
        props.field.triggerOnChange = true;
        switch (field) {
            case "suffix":
                label = this.props.translations["WebCRM.Nukreis.Suffix"];
                props.field.maxLength = 20;
                props.value = this.props.entity.Suffix || "";
                props.onChange = (_, value: string) => {
                    let entity = this.props.entity;
                    entity.Suffix = value;
                    this.props.onChange(entity);
                }
                break;
            case "prefix":
                label = this.props.translations["WebCRM.Nukreis.Prefix"];
                props.field.maxLength = 20;
                props.value = this.props.entity.Prefix || "";
                props.onChange = (_, value: string) => {
                    let entity = this.props.entity;
                    entity.Prefix = value;
                    this.props.onChange(entity);
                }
                break;
            case "description":
                label = this.props.translations["Standard.Beschreibung"];
                props.value = this.props.entity.Description || "";
                props.field.multiLine = true;
                props.onChange = (_, value: string) => {
                    let entity = this.props.entity;
                    entity.Description = value;
                    this.props.onChange(entity);
                }
                break;
        }

        return (
            <FieldInstance label={label}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private createDropDown = (field: "kNr" | "auArt") => {
        let label = "";

        let props = this.factory.getDefaultDropDownProps();
        props.onDataLoaded = () => { }
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";

        switch (field) {
            case "auArt":
                label = this.props.translations["Projekt.Auftragsart"];
                props.value = this.props.entity.AuArt;
                props.dataSource = this.auArts;
                props.onChange = (_, value: number) => {
                    let entity = this.props.entity;
                    entity.AuArt = value;
                    this.props.onChange(entity);
                }
                break;
            case "kNr":
                label = this.props.translations["Field.Auftrag.knr"];
                props.value = this.props.entity.KNr;
                props.dataSource = this.codes;
                props.onChange = (_, value: number) => {
                    let entity = this.props.entity;
                    entity.KNr = value;
                    this.props.onChange(entity);
                }
                break;
        }


        return (
            <FieldInstance label={label}>
                <DropDownList {...props} />
            </FieldInstance>
            
            );
    }

    render() {
        return (
            <div style={{ margin: "5px 5px 0 5px" }}>
                {this.createRangeNumericTextBox("min")}
                {this.createRangeNumericTextBox("max")}
                {this.createRangeNumericTextBox("currentnr")}
                {this.canEditSufAndPrefix ? this.createTextBox("prefix") : null}
                {this.canEditSufAndPrefix ? this.createTextBox("suffix") : null}
                {/*Helper.hasValue(this.codes) ? this.createDropDown("kNr") : null*/}
                {/*Helper.hasValue(this.auArts) ? this.createDropDown("auArt") : null*/}
                {this.createTextBox("description")}
            </div>
            );
    }
}

interface EditNukreisProps {
    entity: NukreisIdEntity;
    translations: StringKeyDictionary<string>;
    onChange: (dataItem: NukreisIdEntity) => void;
}

interface NuKreisIdGridProps extends BaseComponentProps {
    entity: NuKreisIdListEntity;
    translations: StringKeyDictionary<string>;
    onChange:(field: { model: string }, value: NukreisIdEntity[], dataItem?: any) => void;
}

interface NuKreisIdGridState {
    data: NukreisIdEntity[];
    selected: NukreisIdEntity;
}
